/*
 * Dynamic-style applier (CSP-safe).
 *
 * The app CSP forbids inline `style=` attributes (style-src 'self', no
 * 'unsafe-inline'). Per-render values that used to live in inline styles —
 * progress-bar widths, persona-avatar hues, tree-indent depths — are rendered
 * into `data-style-*` attributes instead. This helper reads those attributes
 * and writes them to the matching CSS custom property via the CSSOM
 * (`el.style.setProperty`), which is NOT governed by style-src. The CSS rules
 * in main.css/landing.css consume the variables (e.g. `width: var(--bar-width)`).
 *
 * Declarative map: adding a new dynamic kind is one line here + one CSS rule.
 *   data-style-width="60%"  -> --bar-width: 60%
 *   data-style-hue="210"    -> --persona-hue: 210
 *   data-style-indent="2rem"-> --tree-indent: 2rem
 */
const STYLE_VARS = {
  styleWidth: "--bar-width",
  styleHue: "--persona-hue",
  styleIndent: "--tree-indent",
};

function applyDynamicStyles(root) {
  root = root || document;
  for (const [dataKey, cssVar] of Object.entries(STYLE_VARS)) {
    const attr = `data-${dataKey.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`)}`;
    root.querySelectorAll(`[${attr}]`).forEach((el) => {
      // el.style.setProperty is CSSOM -> CSP-safe (not an inline style attr).
      el.style.setProperty(cssVar, el.dataset[dataKey]);
    });
  }
}

applyDynamicStyles();
// Re-run on HTMX swaps so polled/partial content (progress bars, tables,
// archetype trees) gets its variables applied too.
document.addEventListener("htmx:afterSwap", (e) => applyDynamicStyles(e.target));
